import { protectWithAccountPermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { UserManagementPage } from 'features/userManagement'
import { canViewMembersPermission } from 'hooks/usePermission'
import { z } from 'zod/v4'

const userManagementSearchSchema = z.object({
  status: z.enum(['member', 'pending']).optional().default('member'),
})

export type UserManagementSearch = z.infer<typeof userManagementSearchSchema>

export const Route = createFileRoute('/_authenticated/_layout/settings/users')({
  component: UserManagementPage,
  validateSearch: userManagementSearchSchema,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Team'),
      },
    ],
  }),
  beforeLoad: protectWithAccountPermissions(canViewMembersPermission),
})
